import { render, staticRenderFns } from "./index.vue?vue&type=template&id=579e5c08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e5c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579e5c08')) {
      api.createRecord('579e5c08', component.options)
    } else {
      api.reload('579e5c08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=579e5c08&scoped=true", function () {
      api.rerender('579e5c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/previewProductList/previewProductListFrom/index.vue"
export default component.exports